import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "./Modal.scss";
import CloseIcon from "@mui/icons-material/Close";

function TopModal(props) {
    const scrollableRef = useRef(null);

    useEffect(() => {
        if (props.noScrollToBottom) return;
        // Scroll to the bottom when modal is opened or when content updates
        if (scrollableRef.current) {
            scrollableRef.current.scrollTop =
                scrollableRef.current.scrollHeight;
        }
    }, [props.openModal, props.children]);

    const handleCloseModal = () => {
        if (props.preventClickingOutside) return;
        props.closeModal();
    };

    return ReactDOM.createPortal(
        <>
            <div
                className={`app-modal top-modal${
                    props.modalIndex !== undefined ? `${props.modalIndex}` : ""
                }${props.openModal ? " active" : ""}${
                    props.animationOff ? " no-animation" : ""
                }`}
                style={{
                    top: props.heightFromTop ? props.heightFromTop : "5dvh",
                }}
            >
                <div className="app-modal-content p-0">
                    <div
                        className="sdp-modal-btn"
                        onClick={props.closeModal}
                        style={{ zIndex: 100000 }}
                    >
                        <CloseIcon />
                    </div>
                    {props.header && (
                        <h2 className="border-bottom pb-3 text-center">
                            {props.header}
                        </h2>
                    )}

                    {/* Scrollable container */}
                    <div
                        className="modal-scrollable-content"
                        style={{
                            maxHeight: props.maxHeight
                                ? props.maxHeight
                                : "calc(100dvh - 10dvh)",
                        }}
                        ref={scrollableRef}
                    >
                        {props.children}
                    </div>
                </div>
            </div>
            <div
                onClick={handleCloseModal}
                className={`app-modal-overlay${
                    props.modalIndex !== undefined ? `${props.modalIndex}` : ""
                }${props.openModal ? " active" : ""}`}
            ></div>
        </>,
        document.getElementById("portal")
    );
}

export default TopModal;
